// extracted by mini-css-extract-plugin
module.exports = {"root":"_d15de0","pagination":"_ee1c00"};